"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports.styles = exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _constant = require("../../styles/constant");
var _Icon = _interopRequireDefault(require("../Icon"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
const notificationVariants = (0, _styledSystem.variant)({
  prop: 'variant',
  variants: {
    info: {
      backgroundColor: (0, _constant.get)('colors.feedback.info.light')
    },
    success: {
      backgroundColor: (0, _constant.get)('colors.feedback.success.light')
    },
    warning: {
      backgroundColor: (0, _constant.get)('colors.feedback.warning.light')
    },
    error: {
      backgroundColor: (0, _constant.get)('colors.feedback.danger.light')
    }
  }
});
const notificationSizes = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.xs'),
      lineHeight: (0, _constant.get)('lineHeights.xs'),
      padding: props => "".concat((0, _constant.get)('space.6')(props), " ").concat((0, _constant.get)('space.12')(props)),
      borderRadius: (0, _constant.get)('borderRadius.s')
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.s'),
      lineHeight: (0, _constant.get)('lineHeights.s'),
      padding: props => "".concat((0, _constant.get)('space.10')(props), " ").concat((0, _constant.get)('space.16')(props)),
      borderRadius: (0, _constant.get)('borderRadius.m')
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.m'),
      lineHeight: (0, _constant.get)('lineHeights.m'),
      padding: props => "".concat((0, _constant.get)('space.12')(props), " ").concat((0, _constant.get)('space.20')(props)),
      borderRadius: (0, _constant.get)('borderRadius.l')
    }
  }
});
const notificationMarginSizes = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      margin: props => "".concat((0, _constant.get)('space.2')(props), " 0")
    },
    medium: {
      margin: props => "".concat((0, _constant.get)('space.2')(props), " 0")
    },
    large: {
      margin: props => "".concat((0, _constant.get)('space.4')(props), " 0")
    }
  }
});
const notificationIconSizes = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      margin: props => "0 ".concat((0, _constant.get)('space.8')(props), " 0 0")
    },
    medium: {
      margin: props => "".concat((0, _constant.get)('space.2')(props), " ").concat((0, _constant.get)('space.12')(props), " 0 0")
    },
    large: {
      margin: props => "".concat((0, _constant.get)('space.4')(props), " ").concat((0, _constant.get)('space.12')(props), " 0 0")
    }
  }
});
const variants = exports.variants = {
  notificationVariants,
  notificationSizes,
  notificationMarginSizes,
  notificationIconSizes
};
const styles = exports.styles = (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  border-radius: ", ";\n  flex-direction: row;\n  padding: ", " ", ";\n  > ", " {\n    ", "\n  }\n"])), (0, _constant.get)('space.4'), (0, _constant.get)('space.8'), (0, _constant.get)('space.16'), _Icon["default"], variants.notificationIconSizes);
const Body = _styledComponents["default"].div.attrs(_ref => {
  let {
    fit
  } = _ref;
  return {
    fit
  };
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  line-height: ", ";\n"])), variants.notificationMarginSizes, (0, _constant.get)('lineHeights.20'));
const Content = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
const Heading = _styledComponents["default"].div.attrs(_ref2 => {
  let {
    fit
  } = _ref2;
  return {
    fit
  };
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  line-height: ", ";\n  font-weight: ", ";\n"])), variants.notificationMarginSizes, (0, _constant.get)('lineHeights.20'), (0, _constant.get)('fontWeights.bold'));
const Actions = _styledComponents["default"].div.attrs(_ref3 => {
  let {
    fit
  } = _ref3;
  return {
    fit
  };
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  display: flex;\n  line-height: ", ";\n"])), variants.notificationMarginSizes, (0, _constant.get)('lineHeights.20'));
const LinkWrapper = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n  &:after {\n    padding-left: ", ";\n    content: '\u2022';\n  }\n  &:last-child {\n    :after {\n      content: '';\n    }\n  }\n"])), (0, _constant.get)('space.8'), (0, _constant.get)('space.6'));
const Link = _styledComponents["default"].a(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  text-decoration: underline;\n"])), (0, _constant.get)('colors.functional.grey.900'));
const CloseButton = _styledComponents["default"].button(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  background: none;\n  border: none;\n  padding: ", ";\n  height: 100%;\n  display: inline-flex;\n  cursor: pointer;\n"])), (0, _constant.get)('space.4'));
const Wrapper = _styledComponents["default"].div.attrs(_ref4 => {
  let {
    children
  } = _ref4;
  return {
    children
  };
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  ", "\n"])), styles, variants.notificationVariants, variants.notificationSizes);
const Components = exports.Components = {
  Wrapper,
  Body,
  Content,
  Heading,
  Actions,
  LinkWrapper,
  Link,
  CloseButton
};